/*
 * @Description: 企业实名认证
 * @Date: 2024-11-07 15:21:16
 */
import { route, intercept } from './src/router';

const name = 'enterprise-real';
export { name, route, intercept };
